/**
 * Дані модуля в задачі (task.ext.content, див. apps/api/src/modules/content/extensions.ts):
 * посилання на картку матеріалу чи паспорт послуги, для якого задача є основною.
 */
export type ContentTaskExt =
  | { kind: 'material'; materialId: string; code: string; typeCode: string | null; typeName: string | null; stageKey: string | null; status: string | null }
  | { kind: 'service_passport'; passportId: string; code: string; status: string | null };

const str = (v: unknown): string | null => (typeof v === 'string' && v ? v : null);

/** Розбір task.ext.content без довіри до форми даних; null — у задачі немає даних модуля. */
export function readContentExt(ext: unknown): ContentTaskExt | null {
  if (!ext || typeof ext !== 'object') return null;
  const e = ext as Record<string, unknown>;
  const code = str(e.code);
  if (e.kind === 'material') {
    const materialId = str(e.materialId);
    if (!materialId || !code) return null;
    return { kind: 'material', materialId, code, typeCode: str(e.typeCode), typeName: str(e.typeName), stageKey: str(e.stageKey), status: str(e.status) };
  }
  if (e.kind === 'service_passport') {
    const passportId = str(e.passportId);
    if (!passportId || !code) return null;
    return { kind: 'service_passport', passportId, code, status: str(e.status) };
  }
  return null;
}

/** Глибоке посилання на картку матеріалу (для інших модулів). */
export const materialHref = (id: string) => `/content/materials?material=${encodeURIComponent(id)}`;
/** Глибоке посилання на паспорт послуги. */
export const passportHref = (id: string) => `/content/services?passport=${encodeURIComponent(id)}`;
